import React from "react";
import s from '../css/paginado.module.css';
//import {Link} from 'react-router-dom';

export default function Paginado ({dogsPerPage, allDogs, paginado}){
    const pageNumbers = []
               //Math.ceil() devuelve el entero mayor o igual más próximo a un número dado.
    for (let i = 1; i <= Math.ceil(allDogs/dogsPerPage); i++) {
        pageNumbers.push(i)
    }

    return(
     <nav>
       <ul className = {s.paginado}> 
          { pageNumbers &&
            pageNumbers.map(number =>(
                <li  className={s.li} key={number}>
                <a  onClick={() => paginado(number)}> {number}</a>
                </li>
            ))
          }
       </ul>
     </nav>
    )
}